import Flex from '@eversports/react-components/primitives/Flex'
import Skeleton from '@eversports/react-components/primitives/Skeleton'

const SkeletonPayment = () => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Skeleton variant="text" height="48px" width="224px" />
    <Flex horizontalSpacing="default" marginBottom="wide" fullWidth>
      <Skeleton variant="rectangular" width="40px" height="30px" />
      <Skeleton variant="text" width="50%" />
    </Flex>
    <Skeleton variant="text" width="182px" />
    <Skeleton variant="rectangular" height="40px" width="100%" />
    <Skeleton variant="rectangular" height="40px" width="30%" />
  </Flex>
)

export default SkeletonPayment
